// Central Ant Design theme for the DMS admin panel. Applied via <ConfigProvider>.
// One source of truth for brand color, spacing, radius, and density so pages stop
// hardcoding colors/margins.

export const BRAND = {
  primary: "#2f54eb", // indigo-blue
  sider: "#0b1f3a", // deep navy sidebar
  siderActive: "#1d3a6b",
  success: "#52c41a",
  warning: "#faad14",
  error: "#ff4d4f",
  info: "#2f54eb",
};

// Traffic-light helpers reused by dashboards/tables.
export const TRAFFIC = {
  green: "#52c41a",
  yellow: "#faad14",
  red: "#ff4d4f",
  grey: "#bfbfbf",
};

const themeConfig = {
  token: {
    colorPrimary: BRAND.primary,
    colorInfo: BRAND.info,
    colorSuccess: BRAND.success,
    colorWarning: BRAND.warning,
    colorError: BRAND.error,
    borderRadius: 8,
    fontSize: 14,
    colorBgLayout: "#f4f6fb",
    wireframe: false,
  },
  components: {
    Layout: {
      headerBg: "#ffffff",
      headerHeight: 56,
      headerPadding: "0 20px",
      siderBg: BRAND.sider,
      bodyBg: "#f4f6fb",
    },
    Menu: {
      darkItemBg: BRAND.sider,
      darkSubMenuItemBg: BRAND.sider,
      darkItemSelectedBg: BRAND.siderActive,
      darkItemHoverBg: "rgba(255,255,255,0.06)",
      itemBorderRadius: 8,
      itemMarginInline: 8,
    },
    Table: {
      headerBg: "#f7f9fc",
      headerColor: "#5b6b85",
      rowHoverBg: "#f4f7ff",
      cellPaddingBlock: 12,
      borderColor: "#eef1f6",
    },
    Card: {
      borderRadiusLG: 12,
      paddingLG: 20,
    },
    Statistic: {
      titleFontSize: 13,
    },
    Button: {
      controlHeight: 36,
      primaryShadow: "none",
    },
  },
};

export default themeConfig;
